import { render, staticRenderFns } from "./VisionMision.vue?vue&type=template&id=e4a798fe&scoped=true&"
import script from "./VisionMision.vue?vue&type=script&lang=js&"
export * from "./VisionMision.vue?vue&type=script&lang=js&"
import style0 from "./VisionMision.vue?vue&type=style&index=0&id=e4a798fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a798fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
